import { useState, useEffect } from "react";
import { Lock, Signal, Thermometer } from "lucide-react";

const randomBetween = (min, max) =>
  (Math.random() * (max - min) + min).toFixed(1);

const FooterBar = () => {
  const [data, setData] = useState({
    temp: "41.3",
    sig: "99.7",
    lat: "0.42",
  });

  useEffect(() => {
    const iv = setInterval(() => {
      setData({
        temp: randomBetween(38, 48),
        sig: randomBetween(94, 100),
        lat: randomBetween(0.1, 2.0),
      });
    }, 15000);
    return () => clearInterval(iv);
  }, []);

  return (
    <div
      data-testid="footer-bar"
      className="w-full flex justify-between items-end pb-1.5 px-3 relative z-20 gap-2"
    >
      {/* Top border */}
      <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-cyan-500/30 to-transparent" />

      <div className="flex items-center gap-2 sm:gap-4">
        <FooterStat
          icon={<Thermometer className="w-3 h-3" />}
          label="TEMP"
          value={`${data.temp}C`}
        />
        <span className="hidden sm:block">
          <FooterStat
            icon={<Signal className="w-3 h-3" />}
            label="SIG"
            value={`${data.sig}%`}
          />
        </span>
      </div>

      <div className="hidden md:block font-mono text-[7px] md:text-[9px] tracking-[0.2em] text-cyan-600/50 uppercase truncate">
        Alpha Global Enterprises
      </div>

      <div className="flex items-center gap-2 sm:gap-4">
        <span className="hidden sm:block">
          <FooterStat
            icon={<Lock className="w-3 h-3" />}
            label="ENC"
            value="AES-256"
          />
        </span>
        <FooterStat
          icon={null}
          label="LAT"
          value={`${data.lat}ms`}
        />
      </div>
    </div>
  );
};

const FooterStat = ({ icon, label, value }) => (
  <div className="flex items-center gap-1 font-mono text-[8px] md:text-[9px] tracking-wider">
    {icon && <span className="text-cyan-600">{icon}</span>}
    <span className="text-cyan-700">{label}:</span>
    <span className="text-cyan-400 number-tick">{value}</span>
  </div>
);

export default FooterBar;
